import React, { useEffect, useRef, useState } from 'react';
import ToolKitFilter from './ToolKitFilter';

export function Select(props) {
	const [isOpen, setIsOpen] = useState(false);
	const selectRef = useRef(null);

	const handleClickOutside = (event) => {
		if (selectRef.current && ! selectRef.current.contains(event.target)) {
			setIsOpen(false);
		}
	};

	useEffect(() => {
		document.addEventListener('click', handleClickOutside);

		return () => {
			document.removeEventListener('click', handleClickOutside);
		};
	});

	const toggleSelect = () => {
		setIsOpen(! isOpen );
	};

	const selectAllChecked = () => {
		return props.selectedOptions.length === props.options.length ? 'checked' : '';
	}

	let className = 'toolkit-filterbar-select';
	if ( isOpen ) {
		className += ' open'
	}

	return (
		<div id={'toolkit-filterbar-select-' + props.id} className={className} ref={selectRef}>
			<div className="toolkit-select-label" onClick={toggleSelect}>{props.blankLabel}</div>
			{isOpen && (
				<div className="toolkit-select-dropdown">
					<span className="toolkit-select-dropdown--arrow"></span>
					<ToolKitFilter
						id={'select-' + props.id}
						selectAllChecked={selectAllChecked}
						label={props.label}
						onChangeCallback={props.onChangeCallback}
						className='filter-dropdown--container'
						allCount={props.allCount}
						options={props.options}
						optionsCount={props.options.length}
						selectedOptions={props.selectedOptions}
						labelFunction={props.labelFunction}
					/>
				</div>
			)}
		</div>
	);
}
export default Select;
